export const ROUTE_PREFIX = '';

export const ROUTES = {
  LOGIN: `${ROUTE_PREFIX}/login`,
  SIGNUP: `${ROUTE_PREFIX}/signup`,
  HOME: `${ROUTE_PREFIX}/`,
  DRAFT: {
    CREATE: `${ROUTE_PREFIX}/draft/create`,
    JOIN: `${ROUTE_PREFIX}/draft/join`,
  },
};
